export default __webpack_public_path__ + "static/media/b3c127ef-0a3b-45a9-a8ee-7a5610d2a05e.e462d824.webp";